import { PageHeader } from "@/components/PageHeader";
import { LeadSection } from "@/components/LeadSection";
import { Section, Eyebrow, CTA } from "@/components/kit";
import { Reveal } from "@/components/motion";
import { DuoBanner } from "@/components/DuoBanner";
import { ActDialogue } from "@/components/ActDialogue";
import { ACTS, IMG } from "@/data/content";

export default function Formato() {
  return (
    <>
      <PageHeader
        eyebrow="El Formato · 6 actos"
        eyebrowColor="#FF8A80"
        title={["Seis actos para", "perderse bien con ellas."]}
        subtitle="Un ritmo reconocible para que cada episodio tenga sorpresas sin sentirse confuso. Como un itinerario flexible: sabes de dónde sales, pero no todo lo que encontrarás.
                  Un formato que la audiencia reconoce y que da espacio a la magia."
      />

      <Section className="!pt-6">
        <div className="space-y-16 sm:space-y-24">
          {ACTS.map((a, i) => (
            <Reveal key={a.n} delay={0.05}>
              <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14">
                <div className={`relative ${i % 2 ? "lg:order-2" : ""}`}>
                  <div className="overflow-hidden rounded-[2.5rem] bg-mist shadow-[0_20px_40px_rgb(0,0,0,0.06)]">
                    <img
                      src={a.img}
                      alt={a.title}
                      className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
                    />
                  </div>
                  <span
                    className="absolute -left-2 -top-8 font-display text-7xl sm:text-8xl font-extrabold leading-none tracking-tighter text-transparent"
                    style={{ WebkitTextStroke: "2px #FF8A80" }}
                  >
                    {a.n}
                  </span>
                </div>
                <div className={i % 2 ? "lg:order-1" : ""}>
                  <span className="font-mono text-sm uppercase tracking-[0.25em] text-coral">
                    Acto {a.n}
                  </span>
                  <h3 className="mt-3 font-display text-3xl sm:text-5xl font-extrabold tracking-tight text-ink">
                    {a.title}
                  </h3>
                  <p className="mt-5 text-lg text-ink/70 leading-relaxed">{a.desc}</p>
                  <ActDialogue act={a} />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>

      <DuoBanner
        image={IMG.duoFormat}
        imgSide="right"
        tint="#FF8A80"
        eyebrowColor="#FF8A80"
        title="Luces, cámara… ¡y acción en seis actos!"
        text="No importa el destino: cada episodio de Anto & Bella por el Mundo sigue el mismo ritmo de 6 actos, pensado para que cada aventura se sienta completa. Anto improvisa, Bella pone el ritmo, y la audiencia sabe exactamente qué esperar."
        cta={{ to: "/episodios", label: "Ver los episodios" }}
      />

      <Section alt>
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <Reveal>
            <Eyebrow color="#81D4FA">Para marcas y patrocinadores</Eyebrow>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold leading-none tracking-tighter text-ink">
              Seis actos, seis oportunidades.
            </h2>
            <p className="mt-6 text-lg text-ink/70 leading-relaxed">
             Una marca puede asociarse con 1 acto específico o con los 6 de un episodio completo. El formato fijo garantiza visibilidad consistente en cada destino. Cada acto es un espacio de co-branding. Cada acto es un espacio natural de integración para tu marca. Sin interrupciones forzadas: contenido que la audiencia quiere ver.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="flex flex-wrap gap-3">
            <CTA to="/patrocinadores" variant="coral">
              Para Patrocinadores
            </CTA>
            <CTA to="/marcas" variant="ink">
              Para Marcas
            </CTA>
          </Reveal>
        </div>
      </Section>
      <LeadSection path="/el-formato" alt />
    </>
  );
}
